// Copyright 2018 Ping Identity
//
// Licensed under the MIT License (the "License"); you may not use this file
// except in compliance with the License.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { Component, OnInit } from '@angular/core';
import { AuthorizationService } from '../authorization.service';
import { AuthService } from '../users/auth.service';
import { UserInfo } from '../userinfo';
import { Router } from '@angular/router';
import { newUser } from '../users/user';
import { filter, take } from 'rxjs/operators';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.css']
})
export class CallbackComponent implements OnInit {

    public authorized = false;

    constructor(public authorizationService: AuthorizationService, public router: Router, public legacyAuth: AuthService ) { }

    async ngOnInit() {
        console.log(window.location);
        if (!window.location.hash || window.location.hash.length === 0) {
            const queryString = window.location.search.substring(1); // substring strips '?'
            const path = [window.location.pathname, queryString].join('#');
            window.location.assign(new URL(path, window.location.href).toString());
        } else if (new URLSearchParams(window.location.hash.substring(1)).has('code')) {
            await this.handleAuthorizationCodeCallback();
        } else {
            console.log('did not recognize callback in URL fragment or query');
            this.router.navigate(['']);
        }
    }

    private async handleAuthorizationCodeCallback(): Promise<void> {
        try {
            const u = newUser();
            const tokenResponse = await this.authorizationService.completeAuthorizationRequest();
            u.token = tokenResponse.accessToken;
            console.log(u);
            console.log('received token response: ', tokenResponse);

            const userInfo = await this.getUserInfoOnce();
            const userName = this.getUserName(userInfo);
            if (!userName) {
                console.error('No usable username found in userinfo payload', userInfo);
                this.router.navigate(['']);
                return;
            }

            console.log(userInfo);
            this.legacyAuth.login(userName, '');
        } catch (error) {
            console.error('Callback processing failed', error);
            this.router.navigate(['']);
        }
    }

    private getUserInfoOnce(): Promise<UserInfo> {
        return new Promise((resolve, reject) => {
            this.authorizationService.userInfos()
                .pipe(
                    filter((info: UserInfo | null) => !!info),
                    take(1)
                )
                .subscribe({
                    next: (userInfo: UserInfo) => resolve(userInfo),
                    error: (error: any) => reject(error)
                });
        });
    }

    private getUserName(userInfo: UserInfo): string {
        const details = userInfo as UserInfo & {
            userName?: string;
            username?: string;
            preferred_username?: string;
            email?: string;
            sub?: string;
        };

        return details.userName || details.username || details.preferred_username || details.email || details.sub || '';
    }
}